import { Navigate, useLocation } from 'react-router-dom';

import { useAuth } from '../auth/AuthProvider';

export function RequireAuth({ children }: { children: JSX.Element }): JSX.Element {
  const { partner, loading } = useAuth();
  const location = useLocation();

  if (loading) {
    return <div className="grid place-items-center min-h-[60vh] text-slate-500">Betöltés…</div>;
  }
  if (!partner) {
    return <Navigate to="/login" state={{ from: location }} replace />;
  }
  return children;
}
